export default {
  getChartSettings: {
    server: '/chart-settings/measuring-points/{measuringPointId}/charts/{chart}',
    method: 'get',
  },
  updateChartSettings: {
    server: '/chart-settings/measuring-points/{measuringPointId}/charts/{chart}',
    method: 'put',
  },
};
